{%  block sw_sales_channel_detail_content_tab_general %}
    {% parent %}
    <sw-tabs-item :route="{ name: 'sw.sales.channel.detail.trustpilot' , params: { id: $route.params.id }}"
                  title="Trustpilot">
        Trustpilot
    </sw-tabs-item>
{% endblock %}
